import React, { useEffect } from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";

const MenuConfigurationSearchExtraContent = ({
  menuDataSource,
  setFilterMenuItems,
  setSearcheFilterItems,
  setFilterValue,
  filterValue,
  restaurantId,
}) => {
  const { menuItems } = useSelector((state) => state.menuConfigurationReducer);

  const allItemsCategoriesArray = menuItems?.map((item) => {
    return item.menuCategoryName;
  })?.filter(item => item !== null);

  const categoriesFilterArray = allItemsCategoriesArray
    .filter((element, index) => {
      return allItemsCategoriesArray.indexOf(element) === index;
    })
    .map((item) => {
      return {
        value: item,
        text: item,
      };
    });

  useEffect(() => {
    setFilterValue("Всички");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantId]);

  const onFilter = (value) => {
    const r = menuDataSource.filter((item) => item.menuCategoryName === value);
    setFilterMenuItems(r);
    setSearcheFilterItems(null);
    setFilterValue(value);
  };

  return (
    <>
      <Select
        className="menu-configuration-categories-select"
        value={filterValue}
        options={[
          { text: "Всички", value: "Всички" },
          ...categoriesFilterArray,
        ]}
        onChange={(value) => onFilter(value)}
      />
    </>
  );
};

export default MenuConfigurationSearchExtraContent;
